import api from '../config/api';

// Admin-managed master data (cuisines, dish group tags). One request per page load.
let catalogPromise = null;

export const getCatalog = () => {
  catalogPromise =
    catalogPromise ||
    api
      .get('/catalog')
      .then((res) => ({ cuisines: [], units: [], groups: [], ...res.data }))
      .catch((error) => {
        catalogPromise = null;
        throw error;
      });
  return catalogPromise;
};

const idOf = (value) => (value && typeof value === 'object' ? value._id : value)?.toString() || '';

// Group-tag ids a restaurant carries itself or through its dishes.
export const restaurantGroupTagIds = (restaurant) => {
  const ids = new Set((restaurant.groupTags || []).map(idOf).filter(Boolean));
  (restaurant.product || restaurant.products || restaurant.items || restaurant.menu || []).forEach((p) => {
    const id = idOf(p?.groupTag);
    if (id) ids.add(id);
  });
  return ids;
};
